var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileyAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 61.25,
    y1: 35.25,
    x2: 73.75,
    y2: 30.75,
    id: "Line-3",
    stroke: "#584139",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#BC4E4F",
    cx: 45,
    cy: 45,
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DB7672",
    cx: 41.5,
    cy: 44.5,
    r: 41.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#584139",
    cx: 67.25,
    cy: 38.25,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.75,
    y1: 34.75,
    x2: 16.75,
    y2: 30.75,
    id: "Line-3",
    stroke: "#584139",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.5,
    y1: 32.5,
    x2: 61.5,
    y2: 35.5,
    id: "Line-3",
    stroke: "#584139",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.75,
    y1: 58.75,
    x2: 31.5,
    y2: 58.5,
    id: "Line-3",
    stroke: "#584139",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#584139",
    cx: 22.25,
    cy: 38.25,
    r: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyAngry);
export default __webpack_public_path__ + "static/media/Smiley_angry.80bd4c465c5920f13ad368fa6ab52472.svg";
export { ForwardRef as ReactComponent };